import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid } from '@mui/material';
import TaskTile from './TaskTile';

/**
 * Grid component for displaying build task tiles organized by phase
 * @param {Object} props - Component props
 * @param {Array} props.phaseTasks - Array of task tiles to display for this phase
 * @param {Function} props.onTileClick - Function to handle tile click
 * @param {Function} props.onMenuOpen - Function to open the menu
 * @returns {React.ReactElement} Tasks grid component
 */
const TasksGrid = ({ phaseTasks, onTileClick, onMenuOpen }) => {
  return (
    <Box sx={{ flex: 1, py: 2, mt: 1 }}>
      <Grid container spacing={5}>
        {phaseTasks.map((task) => (
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4} key={task.id}>
            <TaskTile 
              task={task} 
              onClick={onTileClick} 
              onMenuOpen={onMenuOpen} 
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

TasksGrid.propTypes = {
  phaseTasks: PropTypes.array.isRequired,
  onTileClick: PropTypes.func.isRequired,
  onMenuOpen: PropTypes.func.isRequired
};

export default React.memo(TasksGrid);